import { Flex, Text } from '@chakra-ui/react';
import TeamAvatar from 'components/TeamAvatar';

type TProps = {
    title: string;
    img: any;
};

const TeamNameCell = ({ title, img }: TProps) => (
    <Flex alignItems="center" gap="12px">
        <TeamAvatar src={img} />
        <Text color="gray.900" fontSize="16px" letterSpacing="-0.32px" lineHeight={1.5} fontWeight={700}>
            {title}
        </Text>
    </Flex>
);

export default TeamNameCell;
